// @generated by protoc-gen-es v2.9.0 with parameter "target=ts,import_extension=.js"
// @generated from file transportation/v1/truck.proto (package transportation.v1, edition 2023)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { EmptySchema, Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_empty, file_google_protobuf_timestamp, file_google_protobuf_wrappers } from "@bufbuild/protobuf/wkt";
import type { Base, ID, Point } from "../../types_pb.js";
import { file_types } from "../../types_pb.js";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file transportation/v1/truck.proto.
 */
export const file_transportation_v1_truck: GenFile = /*@__PURE__*/
  fileDesc("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", [file_google_protobuf_empty, file_google_protobuf_timestamp, file_google_protobuf_wrappers, file_types]);

/**
 * Truck message definition
 *
 * @generated from message transportation.v1.Truck
 */
export type Truck = Message<"transportation.v1.Truck"> & {
  /**
   * @generated from field: types.ID id = 1;
   */
  id?: ID;

  /**
   * @generated from field: transportation.v1.TruckStatus status = 2;
   */
  status: TruckStatus;

  /**
   * @generated from field: types.Point current_location = 3;
   */
  currentLocation?: Point;

  /**
   * @generated from field: google.protobuf.Timestamp last_location_time = 4;
   */
  lastLocationTime?: Timestamp;

  /**
   * @generated from field: string license_plate = 5;
   */
  licensePlate: string;

  /**
   * @generated from field: google.protobuf.Timestamp license_plate_expiration = 6;
   */
  licensePlateExpiration?: Timestamp;

  /**
   * @generated from field: string vin = 7;
   */
  vin: string;

  /**
   * @generated from field: string model = 8;
   */
  model: string;

  /**
   * @generated from field: double capacity = 9;
   */
  capacity: number;

  /**
   * @generated from field: int32 year = 10;
   */
  year: number;

  /**
   * @generated from field: string country = 11;
   */
  country: string;

  /**
   * @generated from field: string state = 12;
   */
  state: string;

  /**
   * @generated from field: string notes = 13;
   */
  notes: string;

  /**
   * @generated from field: types.ID transportation_type_id = 14;
   */
  transportationTypeId?: ID;

  /**
   * @generated from field: types.ID default_trailer_id = 15;
   */
  defaultTrailerId?: ID;

  /**
   * @generated from field: types.ID facility_id = 16;
   */
  facilityId?: ID;

  /**
   * @generated from field: types.Base base = 17;
   */
  base?: Base;
};

/**
 * Describes the message transportation.v1.Truck.
 * Use `create(TruckSchema)` to create a new message.
 */
export const TruckSchema: GenMessage<Truck> = /*@__PURE__*/
  messageDesc(file_transportation_v1_truck, 0);

/**
 * Request/Response messages for Truck queries
 *
 * @generated from message transportation.v1.GetTruckRequest
 */
export type GetTruckRequest = Message<"transportation.v1.GetTruckRequest"> & {
  /**
   * @generated from field: types.ID id = 1;
   */
  id?: ID;

  /**
   * @generated from field: types.ID organization_id = 2;
   */
  organizationId?: ID;
};

/**
 * Describes the message transportation.v1.GetTruckRequest.
 * Use `create(GetTruckRequestSchema)` to create a new message.
 */
export const GetTruckRequestSchema: GenMessage<GetTruckRequest> = /*@__PURE__*/
  messageDesc(file_transportation_v1_truck, 1);

/**
 * @generated from message transportation.v1.GetTruckResponse
 */
export type GetTruckResponse = Message<"transportation.v1.GetTruckResponse"> & {
  /**
   * @generated from field: transportation.v1.Truck truck = 1;
   */
  truck?: Truck;
};

/**
 * Describes the message transportation.v1.GetTruckResponse.
 * Use `create(GetTruckResponseSchema)` to create a new message.
 */
export const GetTruckResponseSchema: GenMessage<GetTruckResponse> = /*@__PURE__*/
  messageDesc(file_transportation_v1_truck, 2);

/**
 * @generated from message transportation.v1.ListTrucksRequest
 */
export type ListTrucksRequest = Message<"transportation.v1.ListTrucksRequest"> & {
  /**
   * @generated from field: transportation.v1.ListTrucksFilter filter = 1;
   */
  filter?: ListTrucksFilter;

  /**
   * @generated from field: repeated transportation.v1.TruckSortOption sorting = 2;
   */
  sorting: TruckSortOption[];

  /**
   * @generated from field: int32 offset = 3;
   */
  offset: number;

  /**
   * @generated from field: int32 limit = 4;
   */
  limit: number;
};

/**
 * Describes the message transportation.v1.ListTrucksRequest.
 * Use `create(ListTrucksRequestSchema)` to create a new message.
 */
export const ListTrucksRequestSchema: GenMessage<ListTrucksRequest> = /*@__PURE__*/
  messageDesc(file_transportation_v1_truck, 3);

/**
 * @generated from message transportation.v1.ListTrucksFilter
 */
export type ListTrucksFilter = Message<"transportation.v1.ListTrucksFilter"> & {
  /**
   * @generated from field: repeated types.ID ids = 1;
   */
  ids: ID[];

  /**
   * @generated from field: transportation.v1.TruckStatus status = 2;
   */
  status: TruckStatus;

  /**
   * @generated from field: google.protobuf.StringValue license_plate = 3;
   */
  licensePlate?: string;

  /**
   * @generated from field: google.protobuf.StringValue vin = 4;
   */
  vin?: string;

  /**
   * @generated from field: google.protobuf.StringValue model = 5;
   */
  model?: string;

  /**
   * @generated from field: google.protobuf.StringValue transportation_type_id = 6;
   */
  transportationTypeId?: string;

  /**
   * @generated from field: google.protobuf.StringValue search_term = 7;
   */
  searchTerm?: string;

  /**
   * @generated from field: types.ID organization_id = 8;
   */
  organizationId?: ID;

  /**
   * @generated from field: double min_capacity = 9;
   */
  minCapacity: number;

  /**
   * @generated from field: double max_capacity = 10;
   */
  maxCapacity: number;

  /**
   * @generated from field: google.protobuf.Timestamp last_updated_at = 11;
   */
  lastUpdatedAt?: Timestamp;
};

/**
 * Describes the message transportation.v1.ListTrucksFilter.
 * Use `create(ListTrucksFilterSchema)` to create a new message.
 */
export const ListTrucksFilterSchema: GenMessage<ListTrucksFilter> = /*@__PURE__*/
  messageDesc(file_transportation_v1_truck, 4);

/**
 * @generated from message transportation.v1.ListTrucksResponse
 */
export type ListTrucksResponse = Message<"transportation.v1.ListTrucksResponse"> & {
  /**
   * @generated from field: repeated transportation.v1.Truck trucks = 1;
   */
  trucks: Truck[];

  /**
   * @generated from field: int32 total = 2;
   */
  total: number;
};

/**
 * Describes the message transportation.v1.ListTrucksResponse.
 * Use `create(ListTrucksResponseSchema)` to create a new message.
 */
export const ListTrucksResponseSchema: GenMessage<ListTrucksResponse> = /*@__PURE__*/
  messageDesc(file_transportation_v1_truck, 5);

/**
 * Command messages
 *
 * @generated from message transportation.v1.CreateTruckRequest
 */
export type CreateTruckRequest = Message<"transportation.v1.CreateTruckRequest"> & {
  /**
   * @generated from field: transportation.v1.TruckInput input = 1;
   */
  input?: TruckInput;

  /**
   * @generated from field: types.ID organization_id = 2;
   */
  organizationId?: ID;
};

/**
 * Describes the message transportation.v1.CreateTruckRequest.
 * Use `create(CreateTruckRequestSchema)` to create a new message.
 */
export const CreateTruckRequestSchema: GenMessage<CreateTruckRequest> = /*@__PURE__*/
  messageDesc(file_transportation_v1_truck, 6);

/**
 * @generated from message transportation.v1.CreateTruckResponse
 */
export type CreateTruckResponse = Message<"transportation.v1.CreateTruckResponse"> & {
  /**
   * @generated from field: transportation.v1.Truck truck = 1;
   */
  truck?: Truck;
};

/**
 * Describes the message transportation.v1.CreateTruckResponse.
 * Use `create(CreateTruckResponseSchema)` to create a new message.
 */
export const CreateTruckResponseSchema: GenMessage<CreateTruckResponse> = /*@__PURE__*/
  messageDesc(file_transportation_v1_truck, 7);

/**
 * @generated from message transportation.v1.UpdateTruckRequest
 */
export type UpdateTruckRequest = Message<"transportation.v1.UpdateTruckRequest"> & {
  /**
   * @generated from field: types.ID id = 1;
   */
  id?: ID;

  /**
   * @generated from field: transportation.v1.TruckUpdateInput input = 2;
   */
  input?: TruckUpdateInput;

  /**
   * @generated from field: types.ID organization_id = 3;
   */
  organizationId?: ID;
};

/**
 * Describes the message transportation.v1.UpdateTruckRequest.
 * Use `create(UpdateTruckRequestSchema)` to create a new message.
 */
export const UpdateTruckRequestSchema: GenMessage<UpdateTruckRequest> = /*@__PURE__*/
  messageDesc(file_transportation_v1_truck, 8);

/**
 * @generated from message transportation.v1.UpdateTruckResponse
 */
export type UpdateTruckResponse = Message<"transportation.v1.UpdateTruckResponse"> & {
  /**
   * @generated from field: transportation.v1.Truck truck = 1;
   */
  truck?: Truck;
};

/**
 * Describes the message transportation.v1.UpdateTruckResponse.
 * Use `create(UpdateTruckResponseSchema)` to create a new message.
 */
export const UpdateTruckResponseSchema: GenMessage<UpdateTruckResponse> = /*@__PURE__*/
  messageDesc(file_transportation_v1_truck, 9);

/**
 * @generated from message transportation.v1.DeleteTruckRequest
 */
export type DeleteTruckRequest = Message<"transportation.v1.DeleteTruckRequest"> & {
  /**
   * @generated from field: types.ID id = 1;
   */
  id?: ID;

  /**
   * @generated from field: types.ID organization_id = 2;
   */
  organizationId?: ID;
};

/**
 * Describes the message transportation.v1.DeleteTruckRequest.
 * Use `create(DeleteTruckRequestSchema)` to create a new message.
 */
export const DeleteTruckRequestSchema: GenMessage<DeleteTruckRequest> = /*@__PURE__*/
  messageDesc(file_transportation_v1_truck, 10);

/**
 * Input messages
 *
 * @generated from message transportation.v1.TruckInput
 */
export type TruckInput = Message<"transportation.v1.TruckInput"> & {
  /**
   * @generated from field: types.ID id = 1;
   */
  id?: ID;

  /**
   * @generated from field: transportation.v1.TruckStatus status = 2;
   */
  status: TruckStatus;

  /**
   * @generated from field: types.Point current_location = 3;
   */
  currentLocation?: Point;

  /**
   * @generated from field: google.protobuf.Timestamp last_location_time = 4;
   */
  lastLocationTime?: Timestamp;

  /**
   * @generated from field: string license_plate = 5;
   */
  licensePlate: string;

  /**
   * @generated from field: google.protobuf.Timestamp license_plate_expiration = 6;
   */
  licensePlateExpiration?: Timestamp;

  /**
   * @generated from field: string vin = 7;
   */
  vin: string;

  /**
   * @generated from field: string model = 8;
   */
  model: string;

  /**
   * @generated from field: double capacity = 9;
   */
  capacity: number;

  /**
   * @generated from field: int32 year = 10;
   */
  year: number;

  /**
   * @generated from field: string country = 11;
   */
  country: string;

  /**
   * @generated from field: string state = 12;
   */
  state: string;

  /**
   * @generated from field: string notes = 13;
   */
  notes: string;

  /**
   * @generated from field: types.ID transportation_type_id = 14;
   */
  transportationTypeId?: ID;

  /**
   * @generated from field: types.ID default_trailer_id = 15;
   */
  defaultTrailerId?: ID;

  /**
   * @generated from field: types.ID facility_id = 16;
   */
  facilityId?: ID;
};

/**
 * Describes the message transportation.v1.TruckInput.
 * Use `create(TruckInputSchema)` to create a new message.
 */
export const TruckInputSchema: GenMessage<TruckInput> = /*@__PURE__*/
  messageDesc(file_transportation_v1_truck, 11);

/**
 * @generated from message transportation.v1.TruckUpdateInput
 */
export type TruckUpdateInput = Message<"transportation.v1.TruckUpdateInput"> & {
  /**
   * @generated from field: transportation.v1.TruckStatus status = 1;
   */
  status: TruckStatus;

  /**
   * @generated from field: google.protobuf.StringValue current_location = 2;
   */
  currentLocation?: string;

  /**
   * @generated from field: google.protobuf.Timestamp last_location_time = 3;
   */
  lastLocationTime?: Timestamp;

  /**
   * @generated from field: google.protobuf.StringValue license_plate = 4;
   */
  licensePlate?: string;

  /**
   * @generated from field: google.protobuf.Timestamp license_plate_expiration = 5;
   */
  licensePlateExpiration?: Timestamp;

  /**
   * @generated from field: google.protobuf.StringValue vin = 6;
   */
  vin?: string;

  /**
   * @generated from field: google.protobuf.StringValue model = 7;
   */
  model?: string;

  /**
   * @generated from field: google.protobuf.DoubleValue capacity = 8;
   */
  capacity?: number;

  /**
   * @generated from field: google.protobuf.Int32Value year = 9;
   */
  year?: number;

  /**
   * @generated from field: google.protobuf.StringValue country = 10;
   */
  country?: string;

  /**
   * @generated from field: google.protobuf.StringValue state = 11;
   */
  state?: string;

  /**
   * @generated from field: google.protobuf.StringValue notes = 12;
   */
  notes?: string;

  /**
   * @generated from field: types.ID transportation_type_id = 13;
   */
  transportationTypeId?: ID;

  /**
   * @generated from field: types.ID default_trailer_id = 14;
   */
  defaultTrailerId?: ID;

  /**
   * @generated from field: types.ID facility_id = 15;
   */
  facilityId?: ID;
};

/**
 * Describes the message transportation.v1.TruckUpdateInput.
 * Use `create(TruckUpdateInputSchema)` to create a new message.
 */
export const TruckUpdateInputSchema: GenMessage<TruckUpdateInput> = /*@__PURE__*/
  messageDesc(file_transportation_v1_truck, 12);

/**
 * TruckStatus enum
 *
 * @generated from enum transportation.v1.TruckStatus
 */
export enum TruckStatus {
  /**
   * @generated from enum value: TRUCK_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: TRUCK_STATUS_AVAILABLE = 1;
   */
  AVAILABLE = 1,

  /**
   * @generated from enum value: TRUCK_STATUS_IN_USE = 2;
   */
  IN_USE = 2,

  /**
   * @generated from enum value: TRUCK_STATUS_INACTIVE = 3;
   */
  INACTIVE = 3,

  /**
   * @generated from enum value: TRUCK_STATUS_OUT_OF_SERVICE = 4;
   */
  OUT_OF_SERVICE = 4,
}

/**
 * Describes the enum transportation.v1.TruckStatus.
 */
export const TruckStatusSchema: GenEnum<TruckStatus> = /*@__PURE__*/
  enumDesc(file_transportation_v1_truck, 0);

/**
 * @generated from enum transportation.v1.TruckSortOption
 */
export enum TruckSortOption {
  /**
   * @generated from enum value: TRUCK_SORT_OPTION_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: TRUCK_SORT_OPTION_STATUS_ASC = 1;
   */
  STATUS_ASC = 1,

  /**
   * @generated from enum value: TRUCK_SORT_OPTION_STATUS_DESC = 2;
   */
  STATUS_DESC = 2,

  /**
   * @generated from enum value: TRUCK_SORT_OPTION_LAST_LOCATION_TIME_ASC = 3;
   */
  LAST_LOCATION_TIME_ASC = 3,

  /**
   * @generated from enum value: TRUCK_SORT_OPTION_LAST_LOCATION_TIME_DESC = 4;
   */
  LAST_LOCATION_TIME_DESC = 4,

  /**
   * @generated from enum value: TRUCK_SORT_OPTION_LICENSE_PLATE_ASC = 5;
   */
  LICENSE_PLATE_ASC = 5,

  /**
   * @generated from enum value: TRUCK_SORT_OPTION_LICENSE_PLATE_DESC = 6;
   */
  LICENSE_PLATE_DESC = 6,

  /**
   * @generated from enum value: TRUCK_SORT_OPTION_MODEL_ASC = 7;
   */
  MODEL_ASC = 7,

  /**
   * @generated from enum value: TRUCK_SORT_OPTION_MODEL_DESC = 8;
   */
  MODEL_DESC = 8,

  /**
   * @generated from enum value: TRUCK_SORT_OPTION_CAPACITY_ASC = 9;
   */
  CAPACITY_ASC = 9,

  /**
   * @generated from enum value: TRUCK_SORT_OPTION_CAPACITY_DESC = 10;
   */
  CAPACITY_DESC = 10,

  /**
   * @generated from enum value: TRUCK_SORT_OPTION_CREATED_AT_ASC = 11;
   */
  CREATED_AT_ASC = 11,

  /**
   * @generated from enum value: TRUCK_SORT_OPTION_CREATED_AT_DESC = 12;
   */
  CREATED_AT_DESC = 12,

  /**
   * @generated from enum value: TRUCK_SORT_OPTION_UPDATED_AT_ASC = 13;
   */
  UPDATED_AT_ASC = 13,

  /**
   * @generated from enum value: TRUCK_SORT_OPTION_UPDATED_AT_DESC = 14;
   */
  UPDATED_AT_DESC = 14,
}

/**
 * Describes the enum transportation.v1.TruckSortOption.
 */
export const TruckSortOptionSchema: GenEnum<TruckSortOption> = /*@__PURE__*/
  enumDesc(file_transportation_v1_truck, 1);

/**
 * Services
 *
 * @generated from service transportation.v1.TruckQueriesService
 */
export const TruckQueriesService: GenService<{
  /**
   * @generated from rpc transportation.v1.TruckQueriesService.GetTruck
   */
  getTruck: {
    methodKind: "unary";
    input: typeof GetTruckRequestSchema;
    output: typeof GetTruckResponseSchema;
  },
  /**
   * @generated from rpc transportation.v1.TruckQueriesService.ListTrucks
   */
  listTrucks: {
    methodKind: "unary";
    input: typeof ListTrucksRequestSchema;
    output: typeof ListTrucksResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_transportation_v1_truck, 0);

/**
 * @generated from service transportation.v1.TruckCommandsService
 */
export const TruckCommandsService: GenService<{
  /**
   * @generated from rpc transportation.v1.TruckCommandsService.CreateTruck
   */
  createTruck: {
    methodKind: "unary";
    input: typeof CreateTruckRequestSchema;
    output: typeof CreateTruckResponseSchema;
  },
  /**
   * @generated from rpc transportation.v1.TruckCommandsService.UpdateTruck
   */
  updateTruck: {
    methodKind: "unary";
    input: typeof UpdateTruckRequestSchema;
    output: typeof UpdateTruckResponseSchema;
  },
  /**
   * @generated from rpc transportation.v1.TruckCommandsService.DeleteTruck
   */
  deleteTruck: {
    methodKind: "unary";
    input: typeof DeleteTruckRequestSchema;
    output: typeof EmptySchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_transportation_v1_truck, 1);

